import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CommonLayout from "../../layouts/CommonLayout";
import { getAnnouncement } from "../../../api/AnnouncementApi";


const AnnouncementPage = () => {
  const { announcementId } = useParams();
  const [announcement, setAnnouncement] = useState(null);

  useEffect(() => {
    getAnnouncement(announcementId)
      .then((data) => setAnnouncement(data))
      .catch((err) => console.error(err));
  }, [announcementId]);

  if (!announcement) return (
    <div className="flex items-center justify-center h-screen">
        <div className="text-md">로딩 중...</div>
    </div>
  );

  return (
    <CommonLayout title="공지사항">
      <div className="p-4 space-y-4">
        <h1 className="text-xl font-semibold">{announcement.title}</h1>
        <p className="text-sm text-gray-500">{new Date(announcement.createdAt).toLocaleDateString('ko-KR')}</p>
        <hr />
        <div className="text-base whitespace-pre-wrap">{announcement.content}</div>
      </div>
    </CommonLayout>
  );
};

export default AnnouncementPage;
